import { createRouter, createWebHistory } from "vue-router";
import Home from "@/pages/Home.vue";
import ProductDetails from "@/pages/ProductDetails.vue";
import ProductSearch from "@/pages/ProductSearch.vue";
import ShoppingCart from "@/pages/ShoppingCart.vue";
import ProductForm from "@/components/admin/ProductForm.vue";
import LoginForm from "@/pages/LoginForm.vue";
import AdminProductList from "@/pages/admin/AdminProductList.vue";
import AdminOrderList from "@/pages/admin/AdminOrderList.vue";
import AdminOrderDetails from "@/pages/admin/AdminOrderDetails.vue";
import AccountSettings from "@/pages/AccountSettings.vue";
import RegisterForm from "@/pages/RegisterForm.vue";
import ActivityPage from "@/pages/ActivityPage.vue"; 

const routes = [ 
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/mi-cuenta",
    name: "AccountSettings",
    component: AccountSettings,
    meta: { requiresAuth: true }
  },
  {
    path: "/producto/:id",
    name: "ProductDetails",
    component: ProductDetails,
  },
  {
    path: "/productos",
    name: "Products",
    component: ProductSearch,
  },
  {
    path: "/carrito/",
    name: "ShoppingCart",
    component: ShoppingCart,
  },
  {
    path: "/admin",
    name: "AdminArea",
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: "productos",
        name: "AdminProductList",
        component: AdminProductList
      },
      {
        path: "pedidos",
        name: "AdminOrderList",
        component: AdminOrderList
      },
      {
        path: "actividad",
        name: "ActivityPage",
        component: ActivityPage
      },
      {
        path: "pedidos/:orderId",
        name: "AdminOrderDetails",
        component: AdminOrderDetails
      },
      {
        path: "productos/nuevo",
        name: "ProductForm",
        component: ProductForm
      },
      {
        path: "productos/editar/:productId",
        name: "ProductEdit",
        component: ProductForm
      }
    ]
  },
  {
    path: "/iniciar-sesion",
    name: "LoginForm",
    component: LoginForm,
    meta: { redirectIfAuth: true }
  },
  {
    path: "/crear-cuenta",
    name: "RegisterForm",
    component: RegisterForm,
    meta: { redirectIfAuth: true }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/"
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Simplificar el beforeEach sin depender de apiClient
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('accessToken');
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  
  if (to.meta.redirectIfAuth && isAuthenticated) {
    return next('/mi-cuenta');
  }

  if (to.meta.requiresAuth && !isAuthenticated) {
    localStorage.setItem('intendedRoute', to.fullPath);
    return next({
      name: 'LoginForm',
      query: { redirect: to.fullPath }
    });
  }

  if (to.meta.requiresAdmin && !isAdmin) {
    return next('/mi-cuenta');
  }

  next();
});

export default router;